import pic from '@/utils/pic'
const { icon1, icon2, icon3, langzh, langen, langtw, langjp,langar, langxby,langdy,langfy,langhy,langty,langyn,zhsz, jtrz, sfrz, iconchecked, iconcheck,icon1_01,icon1_02,icon1_03,icon1_04,banner01,banner02,banner03 , langydl, langpty} = pic

export default {
  "请输入您的国家":"Inserisci il tuo paese",
  "借贷审核中":"Prestito in verifica",
  "完成":"Completato",
  "可用贷款池":"Pool di prestiti disponibili",
  "直观易用的界面":"Interfaccia intuitiva e facile da usare",
  "访问 3,000 多个市场":"Accedi a oltre 3.000 mercati",
  "实时更新和价格提醒":"Aggiornamenti in tempo reale e avvisi di prezzo",
  "各种技术指标、分析工具和高级图表":"Vari indicatori tecnici, strumenti di analisi e grafici avanzati",
  "先进的对冲策略和综合风险管理工具":"Strategie di copertura avanzate e strumenti completi di gestione del rischio",
  "操作不熟练,试试模拟交易":"Non sei pratico? Prova il trading simulato",
  "访问我们的帮助中心,获取交易指南":"Visita il nostro centro assistenza per guide al trading",
  "希望增进您的交易技巧？":"Vuoi migliorare le tue capacità di trading?",
  "每月提取金额":"Importo prelevato mensilmente",
  "交易者":"Trader",
  "亿":"Miliardi",
  "万":"Diecimila",
  "3000多种品类供您选择":"Oltre 3.000 categorie tra cui scegliere",
  "24小时交易量":"Volume di scambio 24h",
  "线上交易,请选择":"Trading online, scegli",
  "交易所":"Exchange",
  "3000多种品类,包括加密货币,贵金属,外汇, 原油等等":"Oltre 3.000 categorie, tra cui criptovalute, metalli preziosi, forex, petrolio greggio e altro",
  "立即交易":"Fai trading ora",
  "希望增进您的交易技巧":"Vuoi migliorare le tue capacità di trading",
  "访问我们的帮助中心,获取全面交易指南":"Visita il nostro centro assistenza per guide complete al trading",
  "去看看":"Vai a vedere",
  "操作不熟练,试试我们的模 拟交易功能":"Non sei pratico? Prova la nostra funzione di trading simulato",
  "免费体验交易,让您尽快上手":"Prova il trading gratuitamente per iniziare al meglio",
  "马上体验":"Prova subito",
  "充币":"Deposito cripto",
  "提币":"Prelievo cripto",
  "客服":"Assistenza clienti",
  "更多":"Altro",
  "热门品种":"Categorie più popolari",
  "卖出":"Vendi",
  "买入":"Acquista",
  "了解我们的平台":"Scopri la nostra piattaforma",
  "直观易用":"Intuitiva e facile",
  "的界面":"interfaccia",
  "定期提供":"Forniamo regolarmente",
  "3,000多个市场":"oltre 3.000 mercati",
  "的实时更新和 价格警报":"aggiornamenti in tempo reale e avvisi di prezzo",
  "各种技术指标":"Vari indicatori tecnici",
  "分析工具和高级图表":"strumenti di analisi e grafici avanzati",
  "套期保值模式和":"Modalità di copertura e",
  "风险管理工具":"strumenti di gestione del rischio",
  "我们创建了技术领先且人性化的交易平台 ,为您提供贴心完善的交易体验":"Abbiamo creato una piattaforma di trading tecnologicamente avanzata e user-friendly, per offrirti un'esperienza completa e personalizzata",
  "实时新闻咨询":"Notizie in tempo reale",
  "紧跟我们的新闻、产品和活动信息":"Segui le nostre notizie, prodotti e eventi",
  "阅读更多新闻":"Leggi altre notizie",
  "合作伙伴等最新新闻动态":"Ultime novità su partner e altro",
  "AI智能赚币":"Guadagna cripto con AI",
  "出金":"Prelievo fondi",
  "随存随取":"Deposita e preleva quando vuoi",
  "一键即刻取出,从不等待":"Preleva con un clic, senza attese",
  "稳定":"Stabile",
  "最稳健的理财":"La gestione patrimoniale più solida",
  "稳定收益,您的理财助手":"Reddito stabile, il tuo assistente finanziario",
  "执行速度":"Velocità di esecuzione",
  "极速执行":"Esecuzione ultraveloce",
  "所有订单将以毫秒级别速度执行":"Tutti gli ordini vengono eseguiti in millisecondi",
  "每天发放":"Distribuzione giornaliera",
  "当天产生收益":"Genera rendimento lo stesso giorno",
  "当天购买当天产生收益,24小时及时发放收益":"Acquista oggi, genera rendimento oggi, distribuzione in 24 ore",
  "现在就开始":"Inizia ora",
  "交易全球金融市场":"Fai trading sui mercati finanziari globali",
  "支持桌面端与移动端多种方式,您可随时 随地开展交易":"Supporto per desktop e dispositivi mobili, puoi fare trading ovunque e in qualsiasi momento",
  "谷歌下载":"Scarica da Google",
  "下载":"Scarica",
  "公司":"Azienda",
  "关于我们":"Chi siamo",
  "许可证监督":"Supervisione delle licenze",
  "帮助中心":"Centro assistenza",
  "政策":"Politiche",
  "条款与条件":"Termini e condizioni",
  "隐私政策":"Informativa sulla privacy",
  "声明":"Dichiarazioni",
  "法律信息":"Informazioni legali",
  "免责声明":"Disclaimer",
  "风险警告":"Avvertenza sui rischi",
  "关于广告":"Informazioni sulla pubblicità",
  currency: {
    bb: 'Trading spot',
    bba: 'Conto spot',
    hy: 'Trading di contratti',
    jg: 'Trading di opzioni',
    jg1: 'Contratti futures',
    hya: 'Conto contratti'
  },
  home:{
    user:'Scelta degli utenti',
    start:'Inizia a fare trading',
    trading:'Prodotti di trading',
    fee:'Commissioni minime',
    co:'Partner',
    varieties:'Strumenti di trading',
    leading:'All\'avanguardia nell\'innovazione Web3',
    market:'Tendenze del mercato degli strumenti',
    explore:'Esplora possibilità infinite',
    newcurrency:'Nuova funzionalità di sottoscrizione!',
    alimited:'Nuove cripto in arrivo, puoi acquistare quelle che ritieni promettenti',
    get_start:'Inizia subito',
    ai_coin:'Programma AI in corso',
    ai_text:'Inizia a guadagnare con AI, rendimento stabile e redditività elevata',
    loan:'Funzionalità di prestito attiva',
    loan_text:'Se hai bisogno di fondi, puoi richiedere un prestito, erogazione il giorno stesso',
    mobile_pc:'Usa su mobile e PC',
    pc_anytime:'Fai trading ovunque:',
    pc_text:'Forniamo potenti strumenti di analisi grafica: oltre 50 indicatori tecnici e strumenti di analisi. Sicuro, affidabile e con leva elevata, il punto di riferimento per gli investimenti online.',
    mobile_down:'Scarica ora',
    mobile_android:'Android',
    mobile_ios:'Apple Store',
    open_text:'Apri un conto reale o prova il conto demo gratuitamente',
    open_account:'Un unico conto',
    tocomplete:'Completa',
    walletlogin:'Accedi con wallet'
  },
  index: {
    h24: 'Volume 24h',
    header_title: ['Scegli ' + window.GLOBAL.LANG_TITLE.tw + ' per i tuoi asset digitali'],
    header_small_title:'Piattaforma completa per il trading di asset digitali blockchain',
    header_msg: 'Sicura - Stabile - Affidabile',
    register_title: 'Registrati su ' + window.GLOBAL.LANG_TITLE.tw + ' e inizia il tuo viaggio nel trading',
    register_pl: 'Inserisci email o telefono',
    register: 'Registrati',
    featureTitleWhy: 'Perché scegliere noi',
    featureTitle: 'Sicura · Stabile · Affidabile',
    featureMsg: '',
    featureList: [
      { icon: icon1, title: 'Tecnologia di wallet sicura', msg: ['Tecnologia cold/hot wallet sviluppata da team di sicurezza globali, mai subito attacchi.', ''] },
      { icon: icon2, title: 'Servizi cripto completi', msg: ['Supporto spot e derivati, il tuo assistente personale nel mondo cripto.',''] },
      { icon: icon3, title: 'Clienti in tutto il mondo', msg: ['Servizi completi per utenti in oltre 130 paesi.',''] }
    ],
    bannerList: [
      { icon: banner01,title: "Sicurezza e stabilità leader", msg: ["Smart contract per la sicurezza degli asset","Performance di trading reali","Assistenza 24/7"] },
      { icon: banner02,title: "Voglio comprare e vendere con facilità", msg: ["Interfaccia semplice","Aggiornamento immediato del saldo","Maggior parte delle cripto disponibili"] },
      { icon: banner03,title: "Voglio guadagnare con i futures", msg: ["Conto attivo subito","Trading strategico","Trading 24/7, anche nei weekend"] }
    ],
    featureList2: [
      { icon: icon1_01, title: "Trasparenza", msg: ["Performance on-chain tramite blockchain e smart contract",""] },
      { icon: icon1_02, title: "Investimento intelligente", msg: ["Strategie diversificate da esperti di trading quantitativo",""] },
      { icon: icon1_03, title: "Classificazione del rischio", msg: ["Prodotti personalizzati per diversi profili di rischio",""] },
      { icon: icon1_04, title: "Prodotti diversificati", msg: ["Servizi innovativi per tutti i tipi di utenti",""] }
    ],
    featureTitle2: 'Trading ovunque, su qualsiasi dispositivo',
    featureMsg2: 'Supporto iOS, Android e tutte le funzionalità',
    tab: ['Principali', 'Top 24h'],
    thead: ['Coppia', 'Prezzo', 'Massimo 24h', 'Minimo 24h','Variazione', 'Volume 24h', 'Azione'],
    more: 'Vedi altro >',
    btn: 'Trade',
    dealsTitle: 'Servizio di trading completo',
    dealsTab:[
      { title: 'Trading spot', content: 'Scambio di asset digitali, con USDT come valuta di base. Supporto per BTC, ETH, LTC e altri.', src:'/static/image/deals-1.jpg', path: '' },
      { title: 'Trading di contratti', content: 'Derivati digitali, supporto long/short, gestione del rischio avanzata, leva fino a 100x.', src:'/static/image/deals-2.jpg', path: '' }
    ]
  },
  market: {
    tab: ['Preferiti', 'Contratti', 'Spot'],
    thead: ['Valuta', 'Prezzo', 'Var. 24h', 'Min 24h', 'Max 24h','Volume 24h', 'Azione'],
    nodata: 'Nessun dato'
  },
  footer: {
    p: '©Copyright ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.tw + '. Tutti i diritti riservati.',
    dd: [
      { dt: "Chi siamo", dd: [{ title: "Presentazione", id: 1 }, { title: "Centro assistenza", type: 'help' }] },
      { dt: "Supporto", dd: [{ title: "Termini", id: 3 }, { title: "Privacy", id: 5 }] },
      { dt: "Contattaci", icon: true }
    ],
    terms: "Termini",
    serve: "Servizi",
    product: "Prodotti",
  },
  nav: {
    btn: ["Accedi", "Registrati", "Asset","Scarica App"],
    nav: [
      { title: "Mercato", path: "/market" },
      { title: "Trading", path: "/preciousMetal", name: 'preciousMetal'},
      { title: "Finanza", path: "/profit_index",name: 'profit_index' },
    ],
    nav2: [{ title: "I miei asset", path: "/asset" }],
    menus: [
      { icon: langzh, title: "Centro utente", path: "/setting" },
      { icon: langen, title: "Esci" }
    ],
    lang: [
      { icon: langen, lang: "English", key: 'en' },
      { icon: langxby, lang: "España", key: 'es' },
      { icon: langfy, lang: "français", key: 'fr' },
      { icon: langdy, lang: "Deutsche", key: 'de' },
      { icon: langjp, lang: "日本語", key: 'jp' },
      { icon: langhy, lang: "한국어", key: 'kr' },
      { icon: langty, lang: "ไทย", key: 'th' },
      { icon: langyn, lang: "Tiếng Việt", key: 'vn' },
      { icon: langydl, lang: "Italia", key: 'it' },
      { icon: langpty, lang: "Portugal", key: 'pt' },
      { icon: langtw, lang: "繁體中文", key: 'tw' },
    ]
  },
  download:{
    "xz": "Scarica"
  },
  register: {
    dl: ['Registrazione con telefono', 'Registrazione con email'],
    title: 'Crea account',
    country: 'Nazionalità',
    country_info: 'La nazionalità non può essere modificata dopo la registrazione',
    account: 'Account',
    code_text: 'Inserisci il codice',
    code_btn: 'Ottieni codice',
    code_unit: 's',
    code_no_data: 'Il codice non può essere vuoto',
    password_text: 'Inserisci password',
    password_again_text: 'Ripeti password',
    pid_text: 'Codice invito',
    pid_pl: 'Opzionale',
    invitation_code_no_data: 'Il codice invito è obbligatorio',
    xy: 'Termini di servizio',
    xy_no_checked: 'Accetta i termini',
    agree: 'Ho letto e accetto',
    register_btn: 'Registrati',
    bz: ['La nazionalità non è modificabile.', 'Controlla anche la cartella spam.', 'Conserva le tue credenziali.', 'Non usare la stessa password su altri siti.'],
    account_no_data: 'Inserisci l\'account',
    code_no_equality: 'Codice non valido',
    password_no_data: 'Inserisci la password',
    password_no_equality: 'Le password non corrispondono'
  },
  bindmpwd: {
    title: 'Imposta password',
    account: 'Account',
    code_text: 'Inserisci il codice',
    code_btn: 'Ottieni codice',
    code_unit: 's',
    password_text: 'Inserisci password',
    password_again_text: 'Ripeti password',
    code_no_data: 'Codice obbligatorio',
    code_no_equality: 'Codice non valido',
    password_no_data: 'Password obbligatoria',
    password_no_equality: 'Le password non corrispondono',
    bindmpwd_btn: 'Conferma',
    phone_no_data: 'Inserisci il numero di telefono',
    password_login_text: 'Inserisci la password di accesso',
    password_trade_text: 'Password a 6 cifre',
    password_again_tarde_text: 'Password a 6 cifre',
  },
  forgetpwd: {
    title: ['Cambia password', 'Password dimenticata'],
    account: 'Account',
    code_text: 'Inserisci il codice',
    code_btn: 'Ottieni codice',
    code_unit: 's',
    password_text: 'Inserisci password',
    password_again_text: 'Ripeti password',
    phone_no_data: 'Inserisci il telefono',
    account_no_data: 'Inserisci l\'account',
    code_no_data: 'Codice obbligatorio',
    code_no_equality: 'Codice non valido',
    password_no_data: 'Password obbligatoria',
    password_no_equality: 'Le password non corrispondono',
    forgetpwd_btn: 'Conferma'
  },
  bindphone: {
    title: 'Associa numero di telefono',
    phone_text: 'Telefono',
  },
  person: {
    more: 'Carica altro',
    no_more: 'Nessun altro dato',
    index_center:"Centro utente",
    index_menus: [
      { icon: zhsz, title: "Gestione account", path: '/setting' },
      { icon: sfrz, title: "Verifica identità", path: '/sfyz' },
      { icon: sfrz, title: "Verifica base", path: '/smauth' },
      { icon: jtrz, title: "Verifica avanzata", path: '/seniorauth' },
      { icon: jtrz, title: "Verifica indirizzo", path: '/dzrz' },
      { icon: jtrz, title: "Acquisto veloce", path: '/kjmbSelect' },
      { icon: jtrz, title: "Punteggio di credito", path: '/credit' },
      { icon: jtrz, title: "Registro operazioni", path: '/deallog' },
      { icon: jtrz, title: "Registro depositi", path: '/cbjl' },
      { icon: jtrz, title: "Registro prelievi", path: '/tbjl' },
    ],
    cbtb: 'Deposito/Prelievo cripto',
    jymx: 'Dettaglio transazioni',
    xyf: {
      'title': 'Punteggio di credito',
      'pgsj': 'Data valutazione'
    },
    smrz:{
      title:'Verifica identità',
      sure_title:'Verifica superata',
      zj_type:'Tipo di documento',
      zj_info:['1. I dati non sono modificabili', '2. Non possono essere riutilizzati'],
      zj_name:'Nome',
      zj_num:'Numero documento',
      zj_btn:'Conferma',
      zj_rebtn:'Riverifica',
      zj_sebtn:'Verifica avanzata',
      zj_type_array:[{name:'Documento d\'identità',type:'idcard'}],
      idCardArr: [
        { id: 1, name: "Documento d\'identità" },
        { id: 2, name: "Passaporto" },
        { id: 3, name: "Patente di guida" },
        { id: 4, name: "Permesso di soggiorno" },
        { id: 5, name: "Altro" }
      ],
      zj_data:{city:'Nazionalità obbligatoria',type:'Tipo documento obbligatorio',name:'Nome obbligatorio',zj_num:'Numero documento obbligatorio'},
      zsxm: 'Nome completo',
       qsrzsxm: 'Inserisci il nome completo',
       zjlx: 'Tipo documento',
       qxzzjlx: 'Seleziona il tipo documento',
       sfz: 'Documento d\'identità',
       zjhm: 'Numero documento',
       qsrzjhm: 'Inserisci il numero documento',
       sczjz: 'Carica foto documento',
       zjzm: 'Carica fronte',
       zjfm: 'Carica retro',
       qsczjzm: 'Carica il fronte',
       qsczjfm: 'Carica il retro',
       scqmz: 'Carica foto con documento',
       qscscqmz: 'Carica foto con documento',
       zj: [
         { id: 1, title: 'Documento d\'identità' },
         { id: 2, title: 'Passaporto' },
         { id: 3, title: 'Altro' },
       ],
       tj: 'Invia',
       shz: 'In verifica',
       shtg: 'Verificato'
      },
      gjrz:{
      title:'Verifica avanzata',
      zj_info:['1. Formati JPG, JPEG, PNG, max 8MB.','2. Foto chiare, senza modifiche.','3. Foto nitida, visibile il volto.'],
      zj_img:['/static/image/User_Center_Front_view.png','/static/image/User_Center_Back_Shot.png','/static/image/User_Center_Full_picture.png'],
      },
      zhgl:{
      title:'Impostazioni sicurezza',
      bind:[{bind_title:'Reimposta password',bind_name:'Email'},{bind_title:'Imposta password di trading',bind_name:'Email'}]
      },
      wdtg:{
              own_code:'Codice invito personale',
              own_code_url:'Link invito personale',
              own_push_title:'I miei inviti',
              own_push_content:['Guadagno totale stimato','Persone invitate','persone'],
              own_push_content_profit:['Guadagno livello 1','Guadagno livello 2','Guadagno livello 3','Guadagno livello 4'],
              own_push_content_num:['Inviti livello 1','Inviti livello 2','Inviti livello 3','Inviti livello 4'],
              own_push_profit_title: ['ID', 'Guadagno', 'Note','Data'],
              own_push_num_title: ['ID', 'Nome', 'Telefono','Data'],
      },
    jyzt_td: ['Data', 'Dettaglio', 'Importo'],
    cbjl_td: ['Data', 'Valuta', 'Quantità','Stato'],
    sfrz_txt: ['Verifica identità', 'In attesa di verifica', 'Verifica avanzata superata', 'Fronte', 'Retro', 'Verifica','Fallita, riprova'],
    zhsz_txt: ['Livello sicurezza: #', 'Livello sicurezza: #, completa i dati per maggiore sicurezza'],
    zhsz_m: 'Forte',
    zhsz_n: 'Debole',
    zhsz_p: 'Non sicuro',
    zhsz_detailList: [
      { icon: '/static/image/User_Center-password.png', title: 'Password di accesso', value: 'Cambiala periodicamente per sicurezza.', value2:'',btn: 'Modifica', bind_email:'Associa email o telefono',path: '/forgetpwd?type=changepwd' },
      { icon: '/static/image/User_Center-password.png', title: 'Password di trading', value: 'Imposta password di trading', btn: 'Imposta', path: '/bindmpwd' }
    ],
    sksz_txt: ['Impostazioni ricezione', 'Salva'],
    sksz_list: [
      { label: "Username:", pl: "Inserisci username", key: "name" },
      { label: "Banca:", pl: "Inserisci banca", key: "bank_name" },
      { label: "Numero conto:", pl: "Inserisci numero conto", key: "bank_number" },
      { label: "Alipay:", pl: "Inserisci Alipay", key: "alipay_account" },
      { label: "WeChat nickname:", pl: "Inserisci nickname WeChat", key: "weixin_nickname" },
      { label: "WeChat account:", pl: "Inserisci account WeChat", key: "weixin_account" }
    ]
  },
  pasination: {
    first: 'Prima',
    prev: 'Precedente',
    next: 'Successiva',
    last: 'Ultima',
    no_data: 'Nessun dato',
  },
  asset: {
    title: 'I miei asset',
    zjhz: 'Trasferimento fondi',
    cb: 'Deposito',
    gz: 'Valore stimato in USDT',
    atnv: [],
    zh_title: 'Totale asset:',
    index_title: 'Asset',
    address_title: 'Valuta',
    address_txt: ['Seleziona', 'Indirizzo di prelievo', 'Inserisci contenuto', 'Note', 'Elenco indirizzi'],
    address_btn: ['Aggiungi', 'Salva', 'Elimina', 'Modifica'],
    address_td: ['Valuta', 'Indirizzo di prelievo', 'Note', 'Azioni'],
    currency_td: ['Valuta', 'Disponibile', 'Bloccato', 'Equivalente'],
    table_title: 'Totale asset:',
    table_address_title: 'Gestione indirizzi di prelievo',
    table_td: ['Valuta', 'Disponibile', 'Bloccato', 'Equivalente', 'Azioni'],
    table_btn: ['Deposita', 'Preleva', 'Registro', 'Trasferisci'],
    money_text: ['Indirizzo di prelievo', 'Seleziona', 'Quantità', 'Disponibile:', 'Commissione', 'Importo netto', 'Password di trading','Memo','Minimo prelievo '],
    money_btn: 'Preleva',
    xzbz: 'Seleziona valuta',
    money_msg: ['Attenzione', 'Non inviare asset non USDT a questo indirizzo.', 'Supporto solo metodo simple send.'],
    recharge_title: 'Indirizzo di deposito',
    recharge_btn: ['Copia', 'QR Code', 'Deposita'],
    recharge_text: ['Quantità', 'Attenzione', 'Non inviare asset non USDT.', 'Supporto solo simple send.', 'Ricevuta', 'Descrizione (opzionale)','Nome rete'],
    record_title: 'Registro finanziario',
    record_td: ['Quantità', 'Dettaglio', 'Data'],
    transfer_title: 'Trasferimento',
    transfer_btn: ['Tutti', 'Trasferisci'],
    transfer_text: ['Da', 'A', 'Inserisci importo', 'Disponibile:'],
    "bq": "Memo",
   "qsrbq":"Inserisci memo",
   "yhktx":"Prelievo bancario",
   "yhmc": "Nome banca",
   "qsryhmc": "Inserisci nome banca",
   "yhzh": "Conto bancario",
   "qsryhzh":"Inserisci conto bancario",
   "gjhkdm": "Codice SWIFT/BIC",
   "qsrgjhkdm":"Inserisci codice SWIFT",
   "yhdz": "Indirizzo banca",
   "qsryhdz":"Inserisci indirizzo banca",
   "skrxm": "Nome beneficiario",
   "qsrskrxm":"Inserisci nome beneficiario",
   "skrdh": "Telefono beneficiario",
   "qsrskrdh":"Inserisci telefono beneficiario",
   "skrdz": "Indirizzo beneficiario",
   "qsrskrdz":"Inserisci indirizzo beneficiario"
  },
  text: {
    btn: 'Indietro',
    login: 'Effettua il login'
  },
  deal: {
    chooseType: 'Tipo di ordine',
    choose: 'Seleziona',
    balance: 'Saldo:',
    account: ['Conto', 'Disponibile', '/Bloccato', 'Trasferisci'],
    dir: ['Acquista', 'Vendi'],
    dir2: ['Acquistabile', 'Vendibile'],
    sxf: 'Commissione',
    jye: 'Importo',
    cs: 'Preferiti',
    sc_list: ['Mercato', 'Coppia', 'Variazione'],
    sc_h: ['Prezzo corrente', 'Min 24h', 'Max 24h', 'Volume 24h'],
    td_lt: ['Valuta', 'Ultimo prezzo', 'Variazione'],
    k_line_txt: ['≈', '', 'Variazione', 'Massimo', 'Minimo', 'Volume 24h'],
    tabListLTitle: ["Ordini aperti", "Ordini storici"],
    tabListLEntrust: ["Acquista", "Vendi"],
    tabListRTitle: ["Limite", "Mercato"],
    table_btn: ['Annulla'],
    index_td_l: ['Data', 'Controparte', 'Quantità', 'Prezzo', 'Azione'],
    index_td_r: ['Prezzo', 'Direzione', 'Prezzo', 'Quantità'],
    index_td_r2: ['Ultima operazione', 'Data', 'Prezzo', 'Volume'],
    table_txt: ['Completato', 'Annullato'],
    db_1_txt: ['Disponibile', 'Prezzo acquisto', 'Prezzo vendita', 'Quantità acquisto', 'Quantità vendita', 'Importo', 'Acquista al miglior prezzo', 'Vendi al miglior prezzo','Acquista lotto', 'Vendi lotto'],
    db_2_txt: ['Prezzo', 'Leva', 'Seleziona', 'Lotti', '1 lotto = ', 'lotti', 'Valore contratto', 'Margine', 'Acquista al miglior prezzo', 'Vendi al miglior prezzo'],
    pathList: ['Registro contratti', 'Registro operazioni'],
    db_btn: ['Acquista (Long)', 'Vendi (Short)'],
    tabListLTitle2: ['Ordini aperti'],
    lt_btn: ['Chiudi tutto', 'Imposta TP/SL', 'Chiudi', 'Invia', 'Indietro'],
    lt_txt: ['Tasso di rischio:', 'PnL totale:'],
    lt_td: ['Tipo', 'Leva', 'Prezzo apertura', 'Prezzo corrente', 'Margine', 'TP', 'SL', 'Data apertura', 'Lotti', 'PnL', 'Azione'],
    lt_dl: ['Imposta TP/SL', 'TP', 'SL'],
    lt_0_btn: ['Annulla'],
    lt_0_td: ['Contatto', 'Valuta', 'Quantità', 'Prezzo corrente', 'Commissione', 'Azione'],
    lt_1_btn: ['Chiudi'],
    lt_1_txt: ['Chiusura in corso'],
    lt_1_td: ['Tipo', 'Prezzo apertura', 'Prezzo corrente', 'Margine', 'TP', 'SL', 'Data apertura', 'Commissione', 'PnL', 'Azione'],
    node_data: 'Nessun dato',
    lt_3_txt: ['Chiuso', 'Liquidato'],
    lt_3_td: ['Tipo', 'Lotti', 'Prezzo apertura', 'Prezzo chiusura', 'TP', 'SL', 'Margine', 'Margine disponibile', 'Apertura', 'Chiusura', 'Commissione', 'PnL', 'Azione'],
    lt_4_txt: ['Annullato'],
    cm: ['Data emissione', 'Offerta totale', 'Circolazione', 'Prezzo totale', 'Sito ufficiale','Whitepaper','Descrizione'],
    qsrsl: 'Inserisci quantità',
    qsrss: 'Inserisci lotti',
  },
  notice:{
      notice_title:'Centro annunci',
  },
  bzhl:{
    title: 'Finanza AI',
    title1: 'Quant AI',
    ttzbt: 'Guadagno quotidiano',
    wdtg: 'I miei investimenti',
    zztgdzj: 'Capitale investito',
    yjjrsy: 'Rendimento stimato giornaliero',
    ljsy: 'Rendimento totale',
    tgzdd: 'Ordini in corso',
    tgdd: 'Ordine di investimento',
    t1: 'Basso rischio, prelievo flessibile',
    t2: 'Il tuo assistente per la gestione del capitale',
    cljxcp: 'Durata del prodotto',
    dbxe: 'Limite per ordine',
    rsyl: 'Rendimento giornaliero (%)',
    rsyl2: 'Rendimento giornaliero:',
    zq: 'Durata',
    qmr: 'Acquista',
    ckgd: 'Vedi altro',
    cpgk: 'Panoramica prodotto',
    pxsj: 'Data distribuzione',
    tgzj: 'Capitale investito',
    tqsh: 'Riscatta',
    cpld: 'Punti di forza',
    cpgz: 'Regole del prodotto',
    cont: 'Investi USDT in arbitraggio gestito da professionisti, accesso e prelievo flessibili.',
    zj: '100% capitale',
    aqbz: 'Sicurezza',
    jjrsy: 'Rendimento nei festivi',
    bjd: 'continuo',
    cgcrh: 'Dopo il deposito',
    dtqx: 'rendimento dallo stesso giorno',
    ljzr: 'Trasferisci ora',
    xqglgj: 'Strumento di gestione del capitale',
    ddh: 'Ordine',
    tgje: 'Importo',
    tgsj: 'Durata (giorni)',
    yhl: 'Guadagnato / giorni rimanenti',
    xdsj: 'Data ordine',
    zt: 'Stato',
    fh: 'Indietro',
    qrnhsy: 'Rendimento annuale 7gg',
    ygy: '1 mese',
    bn: '6 mesi',
    yn: '1 anno',
    yuan: '€',
    tzfx: 'Rischio',
    shsc: 'Tempo di riscatto',
    di: 'Basso',
    yggzr: '1 giorno lavorativo',
    msgsxf: 'Nessuna commissione di acquisto',
    mr: 'Giornaliero',
    dqfh: 'Rimborso a scadenza',
    ljgm: 'Acquista ora',
    tgz: 'In corso',
    sh: 'Riscatta',
    ywc: 'Completato',
    ysh: 'Riscattato',
    all: 'Tutti',
    "xzbzts": "Semplice, sicuro. Scegli tra più valute.",
    "qtbz": "Altre valute"
  },
  pay:{
    qsrjymm: 'Inserisci password trading (6 cifre)',
    tbmmts: 'Imposta password di trading nel centro utente',
  },
  tips:{
    qxztbdz: 'Inserisci indirizzo di prelievo',
    qsrtbsl: 'Inserisci quantità di prelievo'
  },
  statusText: ['Fallito','In attesa','Completato'],
    dzrz: {
    title: 'Verifica indirizzo',
    sdddz: 'Indirizzo bolletta',
    zdtpsc: 'Carica foto bolletta',
    qsrsdddz: 'Inserisci indirizzo e carica bolletta',
    qsczdtp: 'Carica foto bolletta'
  },
  jgcc: {
    wtgd: 'Ordine in sospeso',
    cj: 'Eseguito',
    jj: 'Introduzione',
    zc: 'In corso',
    lszc: 'Storico posizioni',
    qblx: 'Tutti i tipi',
    xj: 'Prezzo corrente',
    sj: 'Data',
    fx: 'Direzione',
    jg: 'Prezzo',
    sl: 'Quantità',
    jgsj: 'Data scadenza',
    gmj: 'Prezzo acquisto',
    jsj: 'Prezzo liquidazione',
    yk: 'PnL',
    xq: 'Dettagli',
    mz: 'Long',
    md: 'Short',
    dqye: 'Saldo corrente',
    gb: 'Chiudi',
    jxxd: 'Continua ordine',
    qrxd: 'Conferma ordine',
    ddqr: 'Conferma ordine',
    sxf: 'Commissione',
    kyye: 'Saldo disponibile',
    jypz: 'Strumento',
    jyfx: 'Direzione',
    tzje: 'Importo investito',
    tzjeTips: 'L\'importo non può essere 0',
    dqsj: 'Scadenza',
    jssj: 'Data liquidazione',
    gmsj: 'Data acquisto',
    sy: 'Profitto',
    zxje: 'Quantità minima ',
    shi: 'ore',
    fen: 'minuti',
    miao: 'secondi',
    zdje: 'Quantità massima ',
    qsrje: 'Inserisci importo',
    zxtzje: 'Quantità minima ',
    yebz: 'Saldo insufficiente',
    xq: 'Dettagli',
    ddz: 'In attesa',
    jgjl: 'Registro scadenze',
    bz: 'Valuta',
    cz: 'Azione'
  },
  kjmb: {
    title: 'Acquisto veloce',
    fzcg: 'Copiato',
    ljmb: 'Acquista ora',
    lxkf: 'Contatta assistenza'
  },
  news: {
    title: 'I miei messaggi',
    "gg": "Annuncio",
    ckxq: 'Vedi dettagli'
  },
  statusTabs:['In sospeso', 'In esecuzione','Chiuso', 'Annullato'],
  "chongzhi":{
    "zy": "Attenzione",
    "cbxx": "Informazioni deposito",
    "qsrsl": "Inserisci quantità",
    "tips2": "1. Compatibilità wallet/piattaforma: assicurati che la rete sia supportata.",
    "tips3": "2. La rete di deposito deve corrispondere alla rete di destinazione.",
    "tips4": "3. Verifica indirizzo e importo prima del deposito.",
    "tips5": "Attenzione: le transazioni blockchain sono anonime e irreversibili. Controlla attentamente.",
    "tips2_1": "• Non inviare asset non compatibili a questo indirizzo.",
    "tips2_2": "• I tempi di conferma dipendono dalla rete blockchain.",
    "tips2_3": "• L'indirizzo di deposito è stabile e può essere riutilizzato."
  },
  "tibi":{
    "tbxx":"Informazioni prelievo",
    "qsrbq": "Inserisci memo",
    "tbTips1": "• Per sicurezza, i prelievi potrebbero richiedere verifica manuale.",
    "tbTips2": "• Assicurati che il tuo dispositivo sia sicuro.",
    "tbTips3": "• Il prelievo riduce il saldo totale della valuta selezionata."
  },
  "gjlb": "Elenco paesi",
  "qxzgjlb": "Seleziona paese/regione",
  "mbwt":{
    "title": "Domande di sicurezza",
    "mbwt": "Domanda di sicurezza",
    "problem":[
      { "id": 1, "title": "Qual è il nome del tuo migliore amico d'infanzia?" },
      { "id": 2, "title": "Qual è il tuo idolo?" },
      { "id": 3, "title": "Qual è il tuo posto preferito?" }
    ],
    "qtxda": "Inserisci risposta",
    "qsrxmm": "Inserisci nuova password",
    "qqrmm": "Conferma password",
    "sydqmmcz": "Reimposta con password corrente",
    "zhmm": "Recupera password con domanda di sicurezza",
    "ysz": "Impostato",
    "tg": "Salta",
    "tj": "Invia",
    "zyts": "Importante:",
    "zytsCont": "Non condividere le tue risposte e il codice di verifica."
  },
  "zc":{
    "zclb": "Elenco asset",
    "zczh": "Totale asset",
    "yczc": "Nascondi asset con saldo 0"
  },
  "indexNew":{
    "t1": "Piattaforma leader globale",
    "t2": "per asset digitali",
    "t3": "Piattaforma completa per il trading di asset digitali blockchain",
    "t4": "Telefono/Email",
    "t5": "Registrati ora",
    "t6": "Benvenuti clienti da tutto il mondo",
    "t7":"per iniziare il vostro viaggio crypto"
  },
  "newReg":{
    "dl": ['Email','Telefono'],
    "cjzh": "Crea account",
    "sysjhzyx": "Registrati con telefono o email",
    "yhxy": "Termini di servizio",
    "yhxy2": "Ho letto e accetto i termini",
    "yxgz": "Formato email non valido",
    "dhgz": "Formato telefono non valido"
  },
  "indexNew2":{
    "t1": "Fai trading sulla nostra piattaforma",
    "t2": "Con Bitbank",
    "t3": "Bitbank è un exchange crypto sicuro, semplice e potente. Supporto multi-dispositivo, oltre 60 indicatori tecnici. Inizia ora.",
    "ksjy": "Inizia a fare trading",
    "ly": "5 motivi per scegliere Bitbank",
    "item1_t1": "Volume leader",
    "item1_t2": "N.1 * volume crypto",
    "item1_t3": "Alta liquidità, 12 cripto disponibili.",
    "item2_t1": "Alta valutazione da terzi",
    "item2_t2": "Ambiente sicuro",
    "item2_t3": "Wallet cold e multisig per la massima sicurezza.",
    "item3_t1": "App facile e affidabile",
    "item3_t2": "App intuitiva",
    "item3_t3": "Funzionalità complete, trading ovunque.",
    "item4_t1": "24/7",
    "item4_t2": "Depositi sempre disponibili",
    "item4_t3": "Supporto depositi 24 ore su 24, anche nei festivi.",
    "item5_t1": "Smartphone e PC",
    "item5_t2": "Design user-friendly",
    "item5_t3": "Trading semplice anche da mobile.",
    "aqkk": "Sicuro e affidabile",
    "aqkk2": "Trading Bitcoin su Bitbank",
    "cjzh": "Crea un account"
  },
  "xbsg":{
    "title": "Nuove cripto",
    "wdsg": "Le mie sottoscrizioni",
    "scts": "Blocco (giorni):",
    "sy": "Rimasto",
    "ljsg": "Sottoscrivi ora",
    "ysk": "Esaurito",
    "xzjdy": "Iscriviti ora",
    "dy": "Iscriviti",
    "fxjg": "Prezzo di emissione",
    "fxl": "Offerta totale",
    "ssrq": "Data di listing",
    "yxqx": "Validità",
    "qsrsl": "Inserisci quantità",
    "syl": "Rimasto",
    "sgrq": "Data sottoscrizione",
    "sgsl": "Quantità",
    "bz": "Valuta",
    "yebz": "Saldo USDT insufficiente",
    "tgsl": "Quantità approvata",
    "shz": "In verifica",
    "wtg": "Non approvato",
    "ytg": "Approvato"
  },
  "wydb":{
    "title": "Richiedi prestito",
    "db": "Prestito",
    "dbz": "In prestito",
    "jl": "Registro prestiti",
    "jdzq": "Durata (giorni)",
    "qhk": "Rimborsa",
    "ljdb": "Totale prestiti (USD)",
    "dhkbs": "Da rimborsare",
    "jkje": "Importo (USDT)",
    "qsrje": "Inserisci importo",
    "rll": "Tasso giornaliero",
    "hkfs": "Modalità rimborso",
    "dqych": "Rimborso a scadenza",
    "lx": "Interessi",
    "fkjg": "Istituto finanziatore",
    "tpsc": "Prestito fiduciario (carica foto)",
    "fwxx": "Informazioni immobile",
    "srzm": "Prova reddito",
    "yhmx": "Estratto conto",
    "zjz": "Foto documento",
    "yd": "Ho letto e accetto",
    "xy": "Accordo di prestito",
    "sqdb": "Richiedi prestito",
    "gb": "Chiudi",
    "qd": "Conferma",
    "ts": "Accetta i termini del prestito",
    "dbjl": "Registro prestiti",
    "hkhth": "Contratto",
    "wsh": "In verifica",
    "yfk": "Erogato",
    "sqrq": "Data richiesta",
    "zq": "Durata",
    "dbsl": "Importo",
    "zhke": "Totale rimborso",
    "yhke": "Già rimborsato",
    "yhkxq": "Dettaglio rimborso",
    "bqyhk": "Rata corrente (USDT)",
    "hktips": "Assicurati saldo sufficiente",
    "bj": "Capitale",
    "jie": "Prestito",
    "ljhk": "Rimborsa ora",
    "qcz": "Ricarica",
    "yebzqxcz": "Saldo insufficiente, ricarica prima",
    "znj": "Penale",
    "yqts": "Giorni di ritardo"
  },
  "hkxq":{
    "dd":"Ordine",
    "fzhkdz":"Copia indirizzo rimborso",
    "hkxq": "Dettaglio rimborso",
    "zlx": "Interessi totali",
    "zhk": "Totale rimborso",
    "hkjg": "Istituto",
    "qschkpz": "Carica ricevuta rimborso",
    "hkpz": "Ricevuta rimborso"
  },
  "bbjyNew":{
    "jylx": "Tipo di trading",
    "jyze": "Volume totale"
  },
  "bind":{
    "title": "Verifica email",
    "ybd": "Associata",
    "wbd": "Non associata",
    "ts": "Associa email per maggiore sicurezza",
    "qsryxdz": "Inserisci email"
  },
  "tipsNew": {
    "yjj": "Rifiutato",
    "shz": "In riscatto"
  },
  "newIndex2":{
    "zxhy": "Ultimi prezzi",
    "jypt": "Piattaforma",
    "ssyc": "Nascondi",
    "hwzc": "Non registrato?",
    "ljzc": "Registrati ora!",
    "yyzh": "Hai già un account?",
    "hjbj": "Accedi, bentornato!",
    "lmdh": "Menu",
    "ghdjy": "Miglior trading, migliore vita",
    "ghdjy02": "Il centro trading più innovativo al mondo, centinaia di cripto disponibili.",
    "indexCont01": "Sempre al tuo fianco",
    "indexCont02": "Trading spot e margin con esecuzione fulminea.",
    "indexCont03": "API potente",
    "indexCont04": "API intuitiva e opzioni avanzate.",
    "indexCont05": "Asset digitali di qualità",
    "indexCont06": "9 anni 0 incidenti",
    "indexCont07": "Sicurezza top",
    "indexCont08": "Leva fino a 25x",
    "indexCont09": "Trading CFD Bitcoin con leva 25x.",
    "indexCont10": "Fondo di sicurezza",
    "indexCont11": "Liquidità profonda",
    "indexCont12": "Tecnologia avanzata per spread ridotti.",
    "indexCont13": "Scelto dagli utenti",
    "indexCont14": "Paesi coperti",
    "indexCont15": "I nostri vantaggi",
    "indexCont16": "Trading spot e margin con esecuzione rapida.",
    "indexCont17": "Archiviazione sicura",
    "indexCont18": "Wallet cold e MPC per la gestione degli asset.",
    "indexCont19": "Sicurezza prima di tutto",
    "indexCont20": "Tecnologia all'avanguardia per proteggere i tuoi fondi.",
    "indexCont21": "Prelievi rapidi",
    "indexCont22": "Prelievi 24/7 con standard di sicurezza elevati.",
    "indexCont23": "Acquista e vendi criptovalute",
    "indexCont24": "Unisciti alla piattaforma più completa e sicura",
    "indexCont25": "Compra e vendi BTC, ETH, XRP e molte altre cripto.",
    "yqwj": "10M+",
    "dlzc": "Accedi/Registrati",
    "yzm": "Codice di verifica",
    "qrmm": "Conferma password"
  },
  "langNew2":{
    "flzq": "Area premi",
    "qdjl": "Reward check-in",
    "mrqdjl": "Reward giornaliero",
    "qd": "Check-in",
    "yqd": "Già fatto",
    "hdgz": "Regole",
    "qdjl2": "Storico check-in",
    "qdcg": "Check-in completato",
    "yhd": "Ottenuto",
    "lq": "Ritira",
    "dyt": "Giorno 1",
    "det": "Giorno 2",
    "dst": "Giorno 3",
    "dsit": "Giorno 4",
    "dwt": "Giorno 5",
    "dlt": "Giorno 6",
    "dqt": "Giorno 7",
    "jxz": "In corso",
    "cjxnzh": "Crea conto demo",
    "sy":"Home",
    "sc":"Mercato",
    "sclb":"Elenco mercati",
    "jy":"Trading",
    "zh":"Account",
    "db":"Prestito",
    "zchm":"Numero registrazione",
    "cp":"Prodotti",
    "tzjd":"Investimenti e prestiti",
    "zxzc":"Supporto online",
    "xd":"Ordine",
    "zzjptgmnr":"Investi nel futuro, accedi a un sistema finanziario equo.",
    "yy":"App",
    "pqnr":"Banca mobile senza regole tradizionali.",
    "jiami":"Cripto",
    "tgnr":"Depositi cripto per maggiore sicurezza e velocità.",
    "jyl":"Volume medio 24h",
    "ssjmhb":"Cripto quotate",
    "zchy":"Utenti registrati",
    "djxz":"Scarica ora",
    "azsc":"Android",
    "pgsd":"Apple Store",
    "bqxx":'©Copyright ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. Tutti i diritti riservati.',
  },
   "login":{
     login: 'Benvenuto',
     msg: 'Inserisci il tuo account',
     list: ['Telefono/Email', 'Password', 'Password dimenticata?', 'Accedi', 'Non hai un account? Registrati'],
     message: 'Account o password non possono essere vuoti',
     "cdlks":"Accedi per iniziare!",
     "zh":"Account",
     "qsrzh":"Inserisci account",
     "mm":"Password",
     "qsrmm":"Inserisci password",
     "dl":"Accedi",
     "wjmm":"Password dimenticata",
     "qbdl":"Accedi con wallet",
     "myzh":"Non ho un account?",
     "zc":"Registrati",
     "yzm":"Codice verifica",
     "qsryzm":"Inserisci codice",
     "hqyzm":"Ottieni codice",
     "qrmm":"Conferma password",
     "qsrqrmm":"Conferma password",
     "lcmmbyz":"Le password non corrispondono",
     "mmts":"Password 6-12 caratteri",
     "sjtx":"Formato telefono non valido",
     "yxts":"Formato email non valido",
     "qr":"Conferma",
     "sjzc":"Registrati con telefono",
     "sjh":"Telefono",
     "qsrsjh":"Inserisci telefono",
     "yqm":"Codice invito (opzionale)",
     "qsryqm":"Inserisci codice invito",
     "yxzc":"Registrati con email",
     "wyydbzx":"Accetto",
     "yhxy":"Termini di servizio",
     "yhxy2":"Termini di servizio",
     "ysyx":"Informativa sulla privacy",
     "yx":"Email",
     "qsryx":"Inserisci email",
     "yxgsbzc":"Formato email non valido",
     "cjmnzhcg":"Conto demo creato",
     "tcmnzh":"Esci dal conto demo",
     "qbdlts":"Usa l\'app DAPP Wallet",
     },
     "hq":{
     "wh":"Forex",
     "szhb":"Criptovalute",
     "gp":"Azioni",
     "zs":"Indici",
     "eft":"ETF",
     "mc":"Nome",
     "xs":"Variazione 24h %",
     "tb":"Grafico",
     "jg":"Prezzo",
     },
     "user":{
     "wdzh":"Il mio account",
     "zh":"Account:",
     "dk":"Prestito:",
     "sydbzj":"Margine utilizzato:",
     "yqll":"Profitto atteso:",
     "qtgn":"Altre funzioni",
     "cz":"Deposito",
     "tx":"Prelievo",
     "dh":"Scambio",
     "zhyz":"Verifica KYC",
     "zhjl":"Registro account",
     "yqhy":"Invita amici",
     "flzq":"Area premi",
     "ggmm":"Cambia password",
     "sz":"Impostazioni",
     "cjwtjd":"FAQ",
     "fzdz":"Copia indirizzo",
     "sl":"Quantità...",
     "qsrsl":"Inserisci quantità",
     "dd":"Ricevi (USDT):",
     "sczm":"Carica ricevuta",
     "qsczm":"Carica ricevuta",
     "tj":"Invia",
     "czjl":"Registro depositi",
     "ddh":"Ordine",
     "wsh":"In verifica",
     "ywc":"Completato",
     "bz":"Nome:",
     "sl2":"Quantità:",
     "sj":"Data:",
     "srsl":"Inserisci quantità...",
     "dd2":"Ricevi:",
     "qskgzflhd":"Segui le promozioni, pubblicheremo eventi regolarmente",
     "hdlb":"Elenco eventi",
     "ckxq":"Vedi dettagli",
     "wdjl":"I miei premi",
     "yiji":"Livello 1",
     "erji":"Livello 2",
     "sanji":"Livello 3",
     "je":"Importo",
     "sj2":"Data",
     "yyxz":"Seleziona lingua",
     "tcdl":"Esci",
     "je2":"Importo (USD)...",
     "qsrje":"Inserisci importo",
     "jsdz":"Indirizzo ricevente...",
     "qsrjsdz":"Inserisci indirizzo",
     "sjdz":"Importo netto:",
     "sxf":"Commissione:",
     "txsm1":"Il prelievo richiede una commissione del 5%, confermato dai nodi di rete.",
     "txsm2":"Non trasferire cripto a sconosciuti.",
     "tz":"Notifiche",
     "wdyq":"I miei inviti",
     "yhid":"User ID",
     "hdjl":"Ricompensa in USD",
     "yqsm":"Invita amici a partecipare all'AI Quant, noleggiare miner o fare trading per guadagnare ricompense.",
     "yqsy":"Guadagno inviti",
     "yqrs":"Persone invitate",
     "tgljyq":"Invita tramite link",
     "lj":"Link",
     "yqm":"Codice invito",
     "cbtb":"Deposito/Prelievo cripto",
     "jymx":"Dettaglio transazioni",
     "yqhyjl":"Ricompensa inviti",
     "aidd":"Ordini AI Gold",
     "jdls":"Storico prestiti",
     "etfdd":"Ordini ETF",
     "jmhbdd":"Ordini cripto",
     "whdd":"Ordini forex",
     "gpdd":"Ordini azioni",
     "qx":"Annulla",
     "zc":"Asset",
     "zzc":"Totale asset",
     "ky":"Disponibile",
     "zh2":"Equivalente (USD)",
     "xzbz":"Seleziona:",
     "sztkts":"Nota: imposta la password di trading nel centro sicurezza.",
     "jymm":"Password di trading",
     "szjymm":"Imposta password trading",
     "qsrjymm":"Inserisci password trading",
     "zdsl":"Quantità minima",
     "bq":"Memo",
     "qsrbq":"Inserisci memo",
     "yhktx":"Bonifico bancario",
     "yhmc":"Nome banca",
     "qsryhmc":"Inserisci nome banca",
     "yhzh":"Conto bancario",
     "qsryhzh":"Inserisci conto",
     "gjhkdm":"Codice SWIFT",
     "qsrgjhkdm":"Inserisci SWIFT",
     "yhdz":"Indirizzo banca",
     "qsryhdz":"Inserisci indirizzo",
     "skrxm":"Nome beneficiario",
     "qsrskrxm":"Inserisci nome",
     "skrdh":"Telefono beneficiario",
     "qsrskrdh":"Inserisci telefono",
     "skrdz":"Indirizzo beneficiario",
     "qsrskrdz":"Inserisci indirizzo",
     "tbjl":"Registro prelievi",
     "fzcg":"Copiato",
     "aqzx":"Centro sicurezza",
     "yxrz":"Verifica email",
     "ybd":"Associata",
     "wbd":"Non associata",
     "yrz":"Verificata",
     "wrz":"Non verificata",
     "ts":"Associa email per maggiore sicurezza",
     "qsryxdz":"Inserisci email",
     "dlmm":"Password di accesso",
     "mbwtsz":"Domande di sicurezza",
     "mbwt":"Domanda",
     "qtxda":"Inserisci risposta",
     "zyts":"Importante:",
     "zytsCont":"Non condividere risposte e codici.",
     "qsrxmm":"Inserisci nuova password",
     "sydqmmcz":"Reimposta con password corrente",
     "zhmm":"Recupera con domanda di sicurezza",
     "ysz":"Impostata",
     "tg":"Salta",
     "qsrdlmm":"Inserisci password di accesso",
     "bzxz":"Seleziona",
     "zwsj":"Nessun dato",
     "qd":"Conferma",
     "zsgd":"Mostra altro",
     "zdss":"Lotto minimo",
     "mnjy":"Trading demo",
     "sx":"Filtra",
     },
     "zb":{
     "tgdd":"Ordini AI in gestione",
     "tgz":"In gestione",
     "ysh":"Riscattato",
     "shz":"In riscatto",
     "zq":"Durata:",
     "tian":"giorni",
     "syl2":"Rendimento:",
     "rgjg":"Prezzo di sottoscrizione:",
     "rgjg2":"Prezzo sottoscrizione",
     "xdsj":"Data ordine:",
     "yhl":"Guadagnato:",
     "syts":"Giorni rimanenti:",
     "sh":"Riscatta",
     "syl":"Rendimento",
     "bz":"Nome",
     "dl":"Tasso",
     "tgts":"Giorni di gestione:",
     "tgsl":"Quantità",
     "qsrtgsl":"Inserisci quantità",
     "dbxe":"Limite per ordine ",
     "ljtg":"Affida ora",
     "zztg":"Importo investito",
     "yjjrsy":"Rendimento stimato oggi",
     "ljsy":"Rendimento totale",
     "tgzdd":"Ordini in corso",
     "ljzc":"Trasferisci ora",
     "gz":"Regole",
     "cpzq":"Durata prodotto",
     "gm":"Acquista",
     "ts":"Attenzione",
     "shts":"Riscatto anticipato comporta una penale del 5%. Confermi?",
     "xgcs":"Limite acquisti",
     },
     "dk":{
     "dk":"Prestito",
     "dkzh":"Conto prestiti",
     "yzsf":"Verifica la tua identità per ottenere importi maggiori!",
     "ksyz":"Inizia verifica",
     "wxj":"Voglio prendere in prestito...",
     "dkqx":"Durata (giorni):",
     "mrll":"Tasso giornaliero:",
     "lxze":"Interessi totali:",
     "dkts":"I primi 3 giorni senza interessi.",
     "xzj":"Richiedi ora",
     "wyydbzx":"Accetto",
     "dkfwxy":"Accordo di prestito",
     "dkfwxy2":"Accordo di prestito",
     "dkysxy":"Accordo privacy prestiti",
     "dkjl":"Registro prestiti",
     "hth":"Contratto",
     "yfk":"Erogato",
     "lx":"Interessi:",
     "zhke":"Totale rimborso:",
     "znj":"Penale:",
     "znjl":"Tasso penale:",
     "yqts":"Giorni di ritardo:",
     "qhk":"Rimborsa",
     "tpsc":"Prestito fiduciario (carica foto)",
     "fwxx":"Info immobile",
     "srzm":"Prova reddito",
     "yhmx":"Estratto conto",
     "zjz":"Foto documento",
     "ljdk":"Richiedi ora",
     "xm":"Nome",
     "ndxm":"Il tuo nome",
     "qsrndxm":"Inserisci il tuo nome",
     "gj":"Paese",
     "ndgj":"Il tuo paese",
     "qsrndgj":"Inserisci il tuo paese",
     "dz":"Indirizzo",
     "nddz":"Il tuo indirizzo",
     "qsrnddz":"Inserisci il tuo indirizzo",
     "csrq":"Data di nascita",
     "ndcsrq":"La tua data di nascita",
     "qsrndcsrq":"Inserisci la tua data di nascita",
     "dhhm":"Telefono",
     "nddhhm":"Il tuo telefono",
     "qsrnddhhm":"Inserisci il tuo telefono",
     "zj":"Documento",
     "sfzm":"Fronte documento",
     "qscsfzm":"Carica fronte",
     "sffm":"Retro documento",
     "qscsffm":"Carica retro",
     "ddqr":"Conferma ordine",
     "jk":"Prestito:",
     "dkqx2":"Durata:",
     "qrxd":"Conferma ordine",
     "yhkxq":"Dettaglio rimborso",
     "hkqr":"Conferma rimborso",
     "yhk":"Da rimborsare:",
     "jksj":"Data prestito:",
     "ljhk":"Rimborsa ora",
     },
     "jy":{
       "rq":"Data",
       "qqjy":"Registro opzioni",
     "hyjy":"Trading contratti",
     "qqhy":"Contratti opzioni",
     "dqwt":"Ordini aperti",
     'wtz':"In sospeso",
     "hyjl":"Registro contratti",
     "shou":"lotto",
     "dk":"Apri:",
     "zhjg":"Ultimo prezzo:",
     "jyfy":"Commissione:",
     "kfsj":"Data apertura:",
     "gg":"Leva:",
     "pl":"Lotto:",
     "kpj":"Prezzo apertura:",
     "yk":"PnL:",
     "cd":"Annulla",
     "jsj":"Prezzo liquidazione:",
     "fx":"Direzione:",
     "jgsj":"Data scadenza:",
     "gb":"Chiudi",
     "jxxd":"Continua",
     "xj":"Limite:",
     "gm":"Acquista:",
     "sl":"Quantità",
     "fy":"Commissione:",
     "tzbzj":"Regola margine",
     "zyzs":"TP/SL",
     "pc":"Chiudi posizione",
     "mr":"Acquista",
     "zjbzj":"Aggiungi margine",
     "jsbzj":"Riduci margine",
     "yxhy":"Trading contratti:",
     "cc":"Posizione (contratti):",
     "cc2":"Posizione",
     "cwbzk":"Margine posizione:",
     "zdzjbzj":"Margine massimo aggiungibile:",
     "zjbzj2":"Aggiungi margine:",
     "qsrzbzj":"Inserisci margine",
     "yxhy2":"Contratti perpetui",
     "kp":"Chiudibile",
     "zhang":"contratti",
     "xj2":"Limite",
     "zy":"Take Profit",
     "zs":"Stop Loss",
     "ssjyzl":"Cerca strumenti",
     "ddb":"Volume",
     "di":"Min:",
     "gao":"Max:",
     "gb2":"Chiudi:",
     "fz":"minuti",
     "mai":"Acquista:",
     "zhang2":"Long",
     "tie":"Short",
     "sy":"Profitto",
     "kz":"Call",
     "kt":"Put",
     "bndy":"Non inferiore a ",
     "sxbzj":"Margine richiesto:",
     "ky":"Disponibile:",
     "sj":"Mercato",
     "mc":"Vendi",
     "zxtzsl":"Quantità minima ",
     "min":"Min ",
     "max":"Max ",
     "yebz":"Saldo insufficiente",
     "ddz":"In attesa",
     "wtzl":"Volume ordini:",
     "wtjg":"Prezzo ordine:",
     "ycd":"Ordine annullato",
     "lswt":"Registro contratti",
     "qsrzyjg":"Inserisci TP",
     "qsrzsjg":"Inserisci SL",
     "ccsl":"Quantità posizione:",
     "ccjg":"Prezzo posizione:",
     "ggbs":"Leva:",
     "zy2":"TP:",
     "zs2":"SL:",
     "zje":"Totale:",
     "ss":"Lotti:",
     "kcjg":"Prezzo apertura:",
     "bzjl":"Margine:",
     "lscc":"Storico posizioni",
     "gmj":"Prezzo acquisto:",
     "guadan":"Ordine limite",
     "dqjg":"Prezzo corrente:",
     "gdjg":"Prezzo ordine:",
     "pcjg":"Prezzo chiusura:",
     "ccsj":"Tempo in posizione:",
     "gdsj":"Tempo ordine:",
     "pcsj":"Tempo chiusura:",
     "fdjyk":"PnL fluttuante",
     "pcsl":"Quantità da chiudere",
     "qrpc":"Conferma chiusura",
     "ypc":"Chiuso",
     "ss2":"Lotti",
     "qsrss":"Inserisci lotti"
     },
     "gjrz":{
     "sfyz":"Verifica KYC",
     "t1":"1. Formati JPG, JPEG, PNG, max 8MB.",
     "t2":"2. Foto chiare, senza modifiche o coperture.",
     "t3":"3. Foto senza cappello, viso e braccia ben visibili.",
     "t4":"Conferma",
     "bh":"Respinto",
     "shz":"In verifica",
     "shtg":"Verificato",
     "nyrzcg":"Verifica completata",
     "sczjz":"Carica foto documento",
     "sczjzmz":"Carica fronte",
     "sczjbmz":"Carica retro",
     "scgrqmz":"Carica foto con documento",
     "gjlb":"Elenco paesi",
     "qxzgjlb":"Seleziona paese",
     "zsxm":"Nome completo",
     "qsrzsxm":"Inserisci nome completo",
     "zjlx":"Tipo documento",
     "zjhm":"Numero documento",
     "qsrzjhm":"Inserisci numero documento",
     "khh":"Banca",
     "qsrkhh":"Inserisci banca",
     "yhkh":"Numero conto",
     "qsryhkh":"Inserisci numero conto",
     },
     "status":{
     "statusText":['Fallito','In attesa','Completato'],
     },
     "download":{
     "t1":"Trading mobile, ovunque",
     "xz":"Scarica"
     },
     "langNew":{
       "jmm": "Vecchia password",
       "qsrjmm": "Inserisci vecchia password",
       "szhb": "Criptovalute",
       "gjs": "Metalli preziosi",
       "ny": "Energia",
       "yy": "Petrolio",
       "jy": "Trading",
       "jmhb": "Criptovalute",
       "yxhy": "Contratti perpetui",
       "gdjy": "Ordini limite",
       "khh": "Banca",
       "qsrkhh": "Inserisci banca",
       "yhkh": "Numero conto",
       "qsryhkh": "Inserisci numero conto",
     "mnzh":"Conto demo",
     "zjjypt":"Miglior piattaforma di trading",
     "brjmzndxq":"Tecnologia all'avanguardia per tutte le tue esigenze",
     "jx":"Continua",
     "yssm":"Informativa privacy",
     "fxqzc":"Politica antiriciclaggio",
     "jgxkz":"Licenze regolatorie",
     "ckgd":"Vedi altro",
     "gd":"Altro",
     "dd":"Ordine",
     "ckdd":"Vedi ordine",
     "yxdd":"Ordine perpetuo",
     "qqdd":"Ordine opzioni",
     "hand":"1 lotto =",
     "lxwm":"Contattaci",
     "tpfzl":"Trascina qui la tua immagine o",
     "liulang":"Sfoglia",
     "zctpgs":"Supporto: JPG, JPEG2000, PNG",
     "ysr":"Reddito mensile",
     "ndysr":"Il tuo reddito mensile",
     "qsrndysr":"Inserisci il tuo reddito mensile",
     "yqtzje":"Importo investimento previsto",
     "qsrtzje":"Inserisci importo previsto",
     "zszh":"Conto reale",
     "qdl":"Accedi",
     "zx":"Preferiti",
     "hkdz":"Indirizzo rimborso",
     "dkje":"Importo prestito:",
     "zlx":"Interessi totali:",
     "hkze":"Totale rimborso:",
     "qcz":"Ricarica",
     "yebz":"Saldo insufficiente, ricarica",
     "dhje":"Importo da rimborsare:",
     "hkjl":"Registro rimborsi:",
     "hkje":"Importo rimborso:",
     "kyye":"Saldo disponibile:",
     "qb": 'Tutti',
     "lmc": "Nome rete:",
     "search": "Cerca",
     "mrjg":"Prezzo acquisto",
     "lxkf":"Contatta assistenza",
     "wyj":"Penale",
     "yxsj":"Durata:",
     "jssj":"Data fine:",
     "hksj":"Data rimborso:",
     "sysj":"Tempo rimanente:",
     "jkqx":"Durata prestito:",
     "yq":"In ritardo:",
     "qqss":"Il tuo ordine opzioni è scaduto, perdita di",
     "qqlr":"Il tuo ordine opzioni è scaduto, profitto di",
     "bz":"Valuta",
     "dzje":"Importo netto",
     "lxyxzc":"Supporto email",
     },
     "langNew9":{
      "dzje":"Tendenze mercato",
      "lxyxzc":"Inizia il tuo viaggio nel trading digitale",
      "text1":"Inizia creando un account",
      "text2":"Invita amici su MFTG",
      "text3":"Effettua un deposito",
      "text4":"Supporto multi-valuta per iniziare subito",
      "text5":"Inizia a fare trading",
      "text6":"Tante coppie di qualità su MFTG",
      "text7":"Invita amici e guadagna USDT",
      "text8":"Guadagna USDT invitando amici",
      "text9":"Funzionalità di prestito attiva",
      "text10":"Richiedi un prestito, erogazione il giorno stesso",
      "text11":"Fai trading su tutti gli asset",
      "text12":"Forex, cripto, futures, ETF e altro",
      },
      "bank":{
        "text1":"La piattaforma finanziaria più affidabile",
        "text2":"Notizie in tempo reale",
        "text3":"Aggiornamenti dal mondo finanziario",
        "text4":"Inizia a esplorare",
        "text5":"Notizie flash",
        "text6":"Seleziona banca",
        "text7":"Carta bancaria",
        "text8":"Importo...",
        "text9":"Aggiungi carta",
        "text10":"Conto bancario",
        "text11":"Inserisci conto",
        "text12":"ID carta",
        "text13":"Inserisci ID carta",
        "text14":"Codice internazionale",
        "text15":"Inserisci codice",
        "text16":"Inserisci telefono",
        "text17":"Aggiungi",
        "text18":"Elimina carta",
        "text19":"Importo netto",
        "text20":"Informazioni prelievo",
        "text21":"Seleziona carta",
        "text22":"Avvertenze",
        "text23":"Importo minimo prelievo:",
        "text24":"Importo inferiore al minimo non consentito",
        "text25":"• I prelievi potrebbero richiedere verifica manuale.",
        "text26":"• Verifica la sicurezza del dispositivo.",
        "text27":"• Ogni prelievo riduce il saldo totale.",
        "text28":"Registro prelievi",
        "text29":"Tipo di valuta fiat",
      },
      "team":{
        "tdjs":"Il nostro team",
        "wmdtd":"Il nostro team",
        "tdjj":"Offriamo costi ridotti, esecuzione migliore e servizi finanziari sicuri. Unisciti a noi.",
        "gltdjs":"Management team",
        "mc0":"Christian James Oram",
        "mc1":"Ari Cohen",
        "mc2":"David Charles Harrison",
        "mc3":"David Harding",
        "mc4":"Marcus John Fisher",
        "mc5":"Michael Levin",
        "mc6":"Robin Matthews",
        "mc7":"Satya Raito",
        "zc0":"CEO",
        "zc1":"CTO",
        "zc2":"CFO",
        "zc3":"Consulente legale",
        "zc4":"COO",
        "zc5":"CIO",
        "zc6":"Chief Credit Officer",
        "zc7":"Direttore Data & AI",
        "text01":"Sicurezza e trasparenza",
        "text02":"La sicurezza degli utenti è la nostra priorità",
        "text03":"Licenze regolatorie internazionali",
        "text04":"Protocolli di protezione asset",
        "text05":"Audit indipendenti",
        "text06":"Condizioni di trading ottimali",
        "text07":"Esperienza di trading superiore",
        "text08":"Supporto per molteplici strumenti",
        "text09":"Esecuzione ordini efficiente",
        "text10":"Dati K-line professionali",
        "text11":"Pronto a iniziare la tua carriera con noi?",
        "ljks":"Inizia ora",
        "技术副总裁":"Vice Presidente Tecnologico",
        "公共关系与对外事务总监":"Direttore Relazioni Pubbliche",
        "首席战略官":"Chief Strategy Officer",
        "首席人工智能科学家":"Lead AI Scientist",
        "首席风险官":"Chief Risk Officer",
      },
      "aiDetail":{
        "syxq":"Dettaglio guadagni",
        "zsy":"Guadagno totale",
        "rq":"Data",
      },
      kdkje: 'Importo prestito disponibile'
}


// WEBPACK FOOTER //
// ./src/lang/it.js